<label class="fw-bold">Customer Notes</label>
<div class="border border-default p-1 w-100" style="height:200px;overflow-y:scroll;">
    <div *ngFor="let note of billToNotesList">
        <div class="alert alert-success">
            <label class="fw-bold">{{note.customerCode}}</label>
            <div>{{note.notes}}</div>
        </div>
    </div>
    <div *ngFor="let note of shipperNotesList">
        <div class="alert alert-info">
            <label class="fw-bold">{{note.customerCode}}</label>
            <div>{{note.notes}}</div>
        </div>
    </div>
    <div *ngFor="let note of consigneeNotesList">
        <div class="alert alert-primary">
            <label class="fw-bold">{{note.customerCode}}</label>
            <div>{{note.notes}}</div>
        </div>
    </div>
</div>
